import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { onPostLogout } from '@whelk/utils/src/logout';
import { setShowLogoutModal } from '@whelk/store/slices/userSlice';
import PlainModal from '@whelk/components/src/Base/PlainModal';
import Button from '@whelk/components/src/Base/Button';
import { RootState } from '@whelk/store';

function LogoutModal() {
  const dispatch = useDispatch();
  const showLogoutModal = useSelector((state: RootState) => state.user.showLogoutModal);
  const { t } = useTranslation();

  const onConfirm = () => {
    dispatch(setShowLogoutModal(false));
    // 清除历史记录
    onPostLogout({
      showLoginModal: false,
    });
  };

  const onCancel = () => {
    dispatch(setShowLogoutModal(false));
  };

  return (
    <PlainModal
      open={showLogoutModal}
      onClickMask={onCancel}
      onClose={onCancel}
      size='sm'
      title={t('settings_logout')}
    >
      <div className='text-col_text02 pb-8 text-[16px] leading-[22px]'>{t('logout_confirm')}</div>
      <div className='flex w-full justify-end gap-4 text-[14px] leading-[20px]'>
        <Button variant='gray' onClick={onCancel}>
          {t('general_cancel')}
        </Button>
        <Button variant='redText' onClick={onConfirm}>
          {t('general_confirm')}
        </Button>
      </div>
    </PlainModal>
  );
}

export { LogoutModal };
